import api from "api";
import { useMutation } from "react-query";

const useResubmitClaim = (patientId: number) =>
  useMutation((requestBody: any) =>
    api("POST /us_insurance_claims/{id}/resubmit", { params: [patientId], data: { request_body: requestBody } })
  );

export default useResubmitClaim;
